import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";
// @ts-ignore showdown 2.1.0 does not ship TypeScript declarations.
import * as showdown from 'showdown';
import * as katex from 'katex';

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}

.chat-scroll {
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.chat-scroll::-webkit-scrollbar {
  width: 6px;
}

.chat-scroll::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #cbd5e1;
}

.chat-input {
  max-height: 140px;
}

:host ::ng-deep .markdown-content {
  min-width: 0;
  overflow-wrap: anywhere;
}

:host ::ng-deep .markdown-content > :first-child {
  margin-top: 0;
}

:host ::ng-deep .markdown-content > :last-child {
  margin-bottom: 0;
}

:host ::ng-deep .markdown-content pre {
  max-width: 100%;
  overflow-x: auto;
  border-radius: 0.65rem;
}

:host ::ng-deep .markdown-content :not(pre) > code {
  border-radius: 0.3rem;
  background: #f1f5f9;
  padding: 0.15rem 0.35rem;
  color: #6d28d9;
  font-weight: 600;
}

:host ::ng-deep .markdown-content :not(pre) > code::before,
:host ::ng-deep .markdown-content :not(pre) > code::after {
  content: none;
}

:host ::ng-deep .markdown-content table {
  display: block;
  max-width: 100%;
  overflow-x: auto;
  white-space: nowrap;
}

:host ::ng-deep .markdown-content a {
  color: #6d28d9;
  text-underline-offset: 2px;
}

:host ::ng-deep .markdown-content input[type=checkbox] {
  margin-right: 0.35rem;
  border-radius: 0.2rem;
}

:host ::ng-deep .markdown-content .latex-display,
:host ::ng-deep .markdown-content .katex-display {
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

:host ::ng-deep .markdown-content .latex-display {
  margin: 1.15rem 0;
  padding: 0.25rem 0;
}

:host ::ng-deep .markdown-content .latex-display .katex-display {
  margin: 0;
}

:host ::ng-deep .markdown-content .katex {
  font-size: 1.05em;
}

.message-enter {
  animation: message-enter 180ms ease-out both;
}

.typing-dot {
  animation: typing 1.1s infinite ease-in-out;
}

.typing-dot:nth-child(2) {
  animation-delay: 140ms;
}

.typing-dot:nth-child(3) {
  animation-delay: 280ms;
}

@keyframes message-enter {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes typing {
  0%, 60%, 100% {
    opacity: 0.35;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
    transform: translateY(-3px);
  }
}
@page {
  size: A4 portrait;
  margin: 14mm;
}
@media print {
  :host {
    width: auto;
    height: auto;
  }
  :host,
  :host * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .chat-shell,
  .chat-main,
  .chat-scroll,
  .chat-content {
    display: block !important;
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
  }
  .chat-shell,
  .chat-main,
  .chat-scroll {
    background: #fff !important;
  }
  .chat-sidebar,
  .chat-composer,
  .screen-only {
    display: none !important;
  }
  .chat-header {
    height: auto !important;
    min-height: 0;
    padding: 0 0 14px !important;
    background: #fff !important;
    backdrop-filter: none;
  }
  .chat-content {
    padding: 24px 0 0 !important;
  }
  .chat-message {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .message-enter {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
  :host ::ng-deep .markdown-content pre,
  :host ::ng-deep .markdown-content table,
  :host ::ng-deep .markdown-content blockquote {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  :host ::ng-deep .markdown-content pre {
    overflow: visible;
    white-space: pre-wrap;
    word-break: break-word;
  }
  :host ::ng-deep .markdown-content table {
    display: table;
    width: 100%;
    overflow: visible;
    white-space: normal;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service)         public service: Service,@Inject( DomSanitizer    )         private sanitizer: DomSanitizer    ) { }

    private markdownConverter: any = new showdown.Converter({
        ghCompatibleHeaderId: true,
        literalMidWordUnderscores: true,
        openLinksInNewWindow: true,
        simpleLineBreaks: true,
        simplifiedAutoLink: true,
        strikethrough: true,
        tables: true,
        tasklists: true
    });

    public models: any[] = [
        {
            name: 'gemma4:e4b-it-q8_0',
            label: 'Gemma 4 8B',
            description: '빠른 응답에 적합한 균형 잡힌 모델',
            available: null
        },
        {
            name: 'gemma4:26b-a4b-it-q8_0',
            label: 'Gemma 4 26B',
            description: '복잡한 분석과 깊이 있는 답변에 적합한 모델',
            available: null
        }
    ];
    public selectedModel: string = 'gemma4:e4b-it-q8_0';
    public serverOnline: boolean | null = null;
    public statusWarning: string = '';
    public input: string = '';
    public messages: any[] = [];
    public sending: boolean = false;
    public copiedId: number | null = null;
    public messageId: number = 0;
    public suggestions: string[] = [
        '반도체 제조 공정을 쉽게 설명해줘',
        '업무 보고서 초안을 작성해줘',
        '복잡한 내용을 핵심만 요약해줘',
        '아이디어를 단계별 계획으로 정리해줘'
    ];

    public async ngOnInit() {
        await this.service.init();
        this.newConversation();
        await this.loadModels();
    }

    public async loadModels() {
        this.statusWarning = '';
        const response: any = await wiz.call('models');
        if (response && response.code === 200) {
            this.models = response.data.models || this.models;
            this.serverOnline = response.data.server_online;
            this.statusWarning = response.data.warning || '';

            const selected = this.models.find((item: any) => item.name === this.selectedModel);
            if (selected && selected.available === false) {
                const fallback = this.models.find((item: any) => item.available);
                if (fallback) this.selectedModel = fallback.name;
            }
        } else {
            this.serverOnline = false;
            this.statusWarning = 'AI 서버 상태를 확인하지 못했습니다.';
        }
        await this.service.render();
    }

    public newConversation() {
        const welcome = '안녕하세요! 무엇이든 편하게 질문해주세요. 선택한 AI 모델이 대화의 맥락을 이어가며 도와드릴게요.';
        this.input = '';
        this.messages = [{
            id: ++this.messageId,
            role: 'assistant',
            content: welcome,
            renderedContent: this.renderMarkdown(welcome),
            time: this.now(),
            local: true
        }];
        this.scrollToBottom();
    }

    public async selectModel(model: any) {
        if (this.sending) return;
        if (!model || model.available === false) return;

        this.selectedModel = model.name;
        await this.service.render();
    }

    public selectedModelInfo() {
        return this.models.find((item: any) => item.name === this.selectedModel) || this.models[0];
    }

    public async useSuggestion(suggestion: string) {
        this.input = suggestion;
        await this.send();
    }

    public handleKeydown(event: KeyboardEvent) {
        if (!event.shiftKey) {
            event.preventDefault();
            this.send();
        }
    }

    public async send() {
        const content = (this.input || '').trim();
        if (!content || this.sending) return;

        this.messages.push({
            id: ++this.messageId,
            role: 'user',
            content: content,
            time: this.now()
        });
        this.input = '';
        this.sending = true;
        await this.service.render();
        this.scrollToBottom();

        const history = this.messages
            .filter((message: any) => !message.local && !message.failed)
            .map((message: any) => ({ role: message.role, content: message.content }));

        const response: any = await wiz.call('chat', {
            model: this.selectedModel,
            messages: JSON.stringify(history)
        });

        if (response && response.code === 200) {
            const answer = response.data.message;
            this.messages.push({
                id: ++this.messageId,
                role: 'assistant',
                content: answer,
                renderedContent: this.renderMarkdown(answer),
                model: response.data.model,
                metrics: response.data.metrics,
                time: this.now()
            });
        } else {
            this.messages.push({
                id: ++this.messageId,
                role: 'assistant',
                content: this.errorMessage(response),
                time: this.now(),
                failed: true
            });
        }

        this.sending = false;
        await this.service.render();
        this.scrollToBottom();
    }

    public async copyMessage(message: any) {
        try {
            await navigator.clipboard.writeText(message.content);
            this.copiedId = message.id;
            await this.service.render();
            setTimeout(async () => {
                this.copiedId = null;
                await this.service.render();
            }, 1500);
        } catch (error) {
            this.copiedId = null;
        }
    }

    public saveAsPdf() {
        if (this.sending || this.messages.length <= 1) return;

        const originalTitle = document.title;
        const modelLabel = (this.selectedModelInfo().label || 'chat')
            .replace(/[\\/:*?"<>|]+/g, '')
            .trim()
            .replace(/\s+/g, '_');
        const exportedAt = new Date();
        const fileDate = [
            exportedAt.getFullYear(),
            String(exportedAt.getMonth() + 1).padStart(2, '0'),
            String(exportedAt.getDate()).padStart(2, '0')
        ].join('-');
        const restoreTitle = () => {
            document.title = originalTitle;
        };

        document.title = `Semiconductor_AI_${modelLabel}_${fileDate}`;
        window.addEventListener('afterprint', restoreTitle, { once: true });

        try {
            window.print();
        } catch (error) {
            window.removeEventListener('afterprint', restoreTitle);
            restoreTitle();
        }
    }

    public trackMessage(index: number, message: any) {
        return message.id;
    }

    private renderMarkdown(content: string): SafeHtml {
        const { markdown, fragments } = this.extractMath(content || '');
        const html = this.markdownConverter
            .makeHtml(markdown)
            .replace(/<a /g, '<a rel="noopener noreferrer" ');
        let safeHtml = this.sanitizer.sanitize(SecurityContext.HTML, html) || '';

        for (const fragment of fragments) {
            safeHtml = safeHtml.split(fragment.token).join(fragment.html);
        }

        return this.sanitizer.bypassSecurityTrustHtml(safeHtml);
    }

    private extractMath(source: string) {
        const fragments: any[] = [];
        const tokenPrefix = `KATEX${Math.random().toString(36).slice(2).toUpperCase()}`;

        const renderMath = (match: string, formula: string, displayMode: boolean) => {
            formula = (formula || '').trim();
            if (!formula || formula.length > 4000) return match;

            const token = `${tokenPrefix}${fragments.length}END`;
            const html = katex.renderToString(formula, {
                displayMode: displayMode,
                throwOnError: false,
                strict: 'ignore',
                trust: false,
                maxExpand: 1000,
                maxSize: 10,
                output: 'htmlAndMathml'
            });
            fragments.push({ token: token, html: html });

            if (displayMode) {
                return `\n\n<div class="latex-display">${token}</div>\n\n`;
            }
            return token;
        };

        const replaceMath = (text: string) => {
            text = text.replace(/(?<!\\)\$\$([\s\S]+?)(?<!\\)\$\$/g,
                (match, formula) => renderMath(match, formula, true));
            text = text.replace(/\\\[([\s\S]+?)\\\]/g,
                (match, formula) => renderMath(match, formula, true));
            text = text.replace(/\\\((.+?)\\\)/g,
                (match, formula) => renderMath(match, formula, false));
            text = text.replace(/(?<!\\)\$(?![\s$])([^\n$]*?\S)\$(?!\$)/g,
                (match, formula) => renderMath(match, formula, false));
            return text;
        };

        const codePattern = /(```[\s\S]*?```|~~~[\s\S]*?~~~|`[^`\n]*`)/g;
        const markdown = source
            .split(codePattern)
            .map((segment, index) => index % 2 === 1 ? segment : replaceMath(segment))
            .join('');

        return { markdown: markdown, fragments: fragments };
    }

    private errorMessage(response: any) {
        if (response && response.data && response.data.message) return response.data.message;
        if (response && response.responseJSON && response.responseJSON.data) {
            return response.responseJSON.data.message || '응답을 가져오지 못했습니다.';
        }
        return 'AI 서버 응답을 가져오지 못했습니다. 잠시 후 다시 시도해주세요.';
    }

    private now() {
        return new Date().toLocaleTimeString('ko-KR', {
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    private scrollToBottom() {
        setTimeout(() => {
            const container = document.getElementById('chat-messages');
            if (container) container.scrollTop = container.scrollHeight;
        }, 0);
    }
}

export default PageAccessComponent;